exports.install = function(Vue,options){
  Vue.prototype.touchS = function(){
    $('.black-btn').addClass('presClass');
  }
  Vue.prototype.touchE = function(){
    $('.black-btn').removeClass('presClass');
  }
}


// WEBPACK FOOTER //
// ./src/util/pressEvent.js